import { Storage } from '@intelipost-js/secure-providers';

export default {
  setFilter(state, filter) {
    const { dateType, dayRange, warehousesIds } = filter;

    state.filter = filter;

    Storage.set('dashboardFilters', filter);

    // TODO - Feito para a tela de transactions
    Storage.set('viewType', dateType);
    Storage.set('searchTime', dayRange.day);
    Storage.set('warehousesIds', warehousesIds);
  },
};



// WEBPACK FOOTER //
// ./src/features/private/dashboard/store/mutations.js